'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import { ELanguage } from '../Utils/constants.js';
import '../Cascader/constants.js';
import { objToQueryStr } from '../Utils/urlBuilder.js';
import 'react';

var SKILL_TAGS = 'skill-tags/api/v1/skills/suggestion';
function getSuggestionSkills(baseMsUrl, accessToken, searchKeywork, selectedSkills, limit, lang) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams, response, jsonData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (searchKeywork === '') {
                        return [2 /*return*/, []];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    queryParams = __assign(__assign({ query: searchKeywork }, (!selectedSkills ? undefined : { selectedSkill: selectedSkills.join('|') })), (!limit ? undefined : { limit: limit }));
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(SKILL_TAGS, "?").concat(objToQueryStr(queryParams)), {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                'Content-Type': 'application/json',
                                'Accept-Language': lang !== null && lang !== void 0 ? lang : ELanguage.VI
                            }
                        })];
                case 2:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    jsonData = _a.sent();
                    if (jsonData.data && jsonData.data.length > 0) {
                        return [2 /*return*/, jsonData.data.map(function (item) { return ({
                                skillName: item.name,
                                skillId: item.id,
                                skillLevel: 0
                            }); })];
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, []];
            }
        });
    });
}

export { SKILL_TAGS, getSuggestionSkills };
//# sourceMappingURL=services.js.map
